import { render, staticRenderFns } from "./Lobby.vue?vue&type=template&id=d9625ee6&"
import script from "./Lobby.vue?vue&type=script&lang=ts&"
export * from "./Lobby.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports